export default "__VITE_ASSET__ni0$ZYjo__"